'use client';
import React from 'react';
import CommentIcon from '@icons-components/comment-icon';
import Chip from '@pezeshk-book/ui-kit/chip';

const SendComment = () => {
  const scrollToCommentBox = () => {
    const commentSection = document.getElementById('comment-section');
    if (commentSection) {
      commentSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Chip
      onClick={scrollToCommentBox}
      color={'warning'}
      startAdornment={<CommentIcon/>}
      value="ارسال نظر"/>
  );
};

export default SendComment;
